const MAX_SIZE = 500 * 1024; // 500 KB
const MAX_DIMENSION = 1200; // px — sharp on 3x retina
/**
 * Compress an image File to max 500KB, max 1200px side.
 * Tries WebP first, falls back to JPEG. Uses regular Canvas for max compatibility.
 */
export async function compressImage(file) {
    const img = await loadImage(file);
    let { width, height } = img;
    if (width > MAX_DIMENSION || height > MAX_DIMENSION) {
        const ratio = Math.min(MAX_DIMENSION / width, MAX_DIMENSION / height);
        width = Math.round(width * ratio);
        height = Math.round(height * ratio);
    }
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, width, height);
    // Try WebP first, fall back to JPEG
    const formats = [
        { mime: 'image/webp', ext: '.webp' },
        { mime: 'image/jpeg', ext: '.jpg' },
    ];
    for (const fmt of formats) {
        let quality = 0.92;
        let blob = null;
        while (quality > 0.4) {
            blob = await canvasToBlob(canvas, fmt.mime, quality);
            if (!blob)
                break; // format not supported
            if (blob.size <= MAX_SIZE) {
                return new File([blob], file.name.replace(/\.\w+$/, fmt.ext), {
                    type: fmt.mime,
                });
            }
            quality -= 0.05;
        }
        // If we got a blob but it's still over limit at min quality, return it anyway
        if (blob) {
            return new File([blob], file.name.replace(/\.\w+$/, fmt.ext), {
                type: fmt.mime,
            });
        }
    }
    // Should never reach here, but return original as last resort
    return file;
}
function loadImage(file) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = URL.createObjectURL(file);
    });
}
function canvasToBlob(canvas, type, quality) {
    return new Promise((resolve) => {
        canvas.toBlob((blob) => {
            // Some browsers return a blob with wrong mime when format isn't supported
            if (blob && blob.type === type)
                resolve(blob);
            else
                resolve(null);
        }, type, quality);
    });
}
